import { render, staticRenderFns } from "./ActionMenu.vue?vue&type=template&id=10f9a68d"
import script from "./ActionMenu.vue?vue&type=script&lang=ts"
export * from "./ActionMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ActionMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./ActionMenu.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxButtonSecondary: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Secondary.vue').default,ExportsPortfolioExcelExport: require('/home/runner/work/assessment-service/assessment-service/frontend/components/exports/PortfolioExcelExport.vue').default,ExportsKfwExport: require('/home/runner/work/assessment-service/assessment-service/frontend/components/exports/KfwExport.vue').default,IxDialogChangeHiddenKpiSettings: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/ChangeHiddenKpiSettings.vue').default})
